import { render, staticRenderFns, recyclableRender, components } from "./wearhouse.vue?vue&type=template&id=13d5c74a&scoped=true&"
var renderjs
import script from "./wearhouse.vue?vue&type=script&lang=js&"
export * from "./wearhouse.vue?vue&type=script&lang=js&"
import style0 from "./wearhouse.vue?vue&type=style&index=0&id=13d5c74a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../HBuilderX.3.8.4.20230531/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d5c74a",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/tabBar/wearhouse/wearhouse.vue"
export default component.exports